export default "__VITE_ASSET__D$OIAJK0__"